import ReactDOM from 'react-dom/client';

export function mountApplication(rootElement, tree) {
    // The pre-renderer saves mounted browser DOM after effects, rather than
    // React server markup. Its state and text-node boundaries can differ from
    // the initial render, even on the same route. Keep the static HTML for
    // indexing, then mount with the visitor's current account and preferences.
    const root = ReactDOM.createRoot(rootElement);
    root.render(tree);
    return root;
}
